import { FormTemplate } from "components/modal/templates";
import { formatDateForDocumentTag } from "helpers/date";
import moment from "moment";
import React from "react";
import WithoutSigningFilesInfo from "../withoutSigningFilesInfo";
import { config, initialState } from "./config";

class CreateUniversalTransferDocument extends FormTemplate {
    close = (data = false) => {
        this.setState({ isLoading: false });
        this.props.back?.(data);
    };

    handleCreate = (withoutSigningFiles) => (e) => {
        this.setState({ withoutSigningFiles }, () => this.handleSubmit(e));
    };

    render = () => this.renderBody();

    sendRequest = () => {
        return this.props.action({
            bidIds: [this.props.id],
            classificationTypeId: this.state.classificationTypeId,
            manualValues: {
                documentDate: formatDateForDocumentTag(this.state.documentDate),
            },
            type: this.state.type,
            ...(this.state.withoutSigningFiles ? { withoutSigningFiles: true } : {}),
        });
    };

    renderBodyInner = () => {
        const { documentDate, type, classificationTypeId } = this.props.config;
        return (
            <>
                <WithoutSigningFilesInfo />
                {this.renderDateField(documentDate)}
                {this.renderSelect(type)}
                {this.renderSelect(classificationTypeId)}
            </>
        );
    };

    renderActionSend = () => {
        const cname = "btn btn-brand btn-sm modal-window__footer-action";
        return (
            <>
                <button type="button" className={cname} onClick={this.handleCreate(false)}>
                    Создать документ
                </button>
                <button
                    type="button"
                    className="btn btn-outline-primary btn-sm modal-window__footer-action"
                    onClick={this.handleCreate(true)}
                >
                    Создать документ без печати и подписи
                </button>
            </>
        );
    };
}

export default function ConfiguredCreateUniversalTransferDocument(props) {
    const formInitialState = {
        ...initialState,
        documentDate: moment().format("YYYY-MM-DD"),
    };

    return <CreateUniversalTransferDocument {...props} config={config} initialState={formInitialState} />;
}
